import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import './i18n/config';
import './config/env';
import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: 'https://fc68e9cdb01008b67e72af64a022fd9b@o4510392026791936.ingest.de.sentry.io/4510392146985040',
  sendDefaultPii: true,
});

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
